import { render, staticRenderFns } from "./_taskNoClientWarning.vue?vue&type=template&id=24daed51"
import script from "./_taskNoClientWarning.vue?vue&type=script&lang=js"
export * from "./_taskNoClientWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports